import { EventInput } from '@fullcalendar/core';
import {
  getExternalEventInteractionHandles,
  getExternalEventResponseState,
  isExternalEventAllDay,
} from '@griply/utils';
import { ExternalCalendarEventExtendedProps } from 'shared/lib/full-calendar';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

export const mapExternalEventToFullCalendarEvent = (
  externalEvent: ExternalCalendarEvent,
  editable = false,
): EventInput => {
  const handles = getExternalEventInteractionHandles(externalEvent);
  const canEdit = editable && !externalEvent.pending;

  return {
    id: externalEvent.id,
    title: externalEvent.title,
    // All-day events carry a `date`; their `end.date` is exclusive — exactly what
    // FullCalendar expects — so a multi-day event spans natively as one bar.
    // Timed events keep their `dateTime`s and FullCalendar slices multi-day ones
    // across the time-grid columns itself.
    allDay: isExternalEventAllDay(externalEvent),
    start:
      externalEvent.start.dateTime ?? externalEvent.start.date ?? undefined,
    end: externalEvent.end.dateTime ?? externalEvent.end.date ?? undefined,
    extendedProps: {
      externalId: externalEvent.id,
      url: handles.url,
      color: externalEvent.color,
      name: externalEvent.title,
      connectionId: handles.connectionId,
      calendarId: handles.calendarId,
      isRecurring: !!externalEvent.isRecurring,
      editable: canEdit,
      isOrganizer: handles.isOrganizer,
      responseState: getExternalEventResponseState(externalEvent),
      preview: handles.preview,
    } satisfies ExternalCalendarEventExtendedProps,
    editable: canEdit,
  };
};
